
import "./App.css";
import React, { useEffect, useState } from 'react'

import './index.css';
import Contact from './component/Contact';
import Home from './component/Home';
import About from './component/About';
import Services from './component/Services';
import Portfolio from './component/Portfolio';
import Footer from './component/Footer';
import Navbar from './component/Navbar';
import download from './img/download.png';
import downloadDark from './img/downloadDark.png';
import cv from './img/cv.pdf';

function App() {
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem('theme') === 'dark'
  ); // Initialize based on saved preference

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]); // Re-run whenever `darkMode` changes

  const toggleDarkMode = () => setDarkMode((prevMode) => !prevMode);
  return (
    <>
    <div className={`font-nunito dark`}>

     <div id='home' className={`lg:h-screen ${darkMode ? 'bg-gradient-to-t from-orange-950' : 'bg-gradient-to-t from-purple-200'} relative overflow-hidden`}>
        <Navbar darkMode={darkMode} toggleDarkMode={toggleDarkMode}/>
          <Home darkMode={darkMode}/>        
         </div>
           <div className={darkMode ? 'bg-neutral-950': 'bg-white'}>
            <About darkMode={darkMode} contact={'contact'} about={'about'}/>
             <Services darkMode={darkMode} services={'services'}/>
             <Portfolio darkMode={darkMode} work={'work'}/>
             <Contact darkMode={darkMode} contact={'contact'}/>
     <a 
      href={cv} 
      download="Hi-.pdf" 
      className={`${darkMode?'bg-neutral-900 border-orange-500  shadow-2xl':'bg-white border-purple-800  shadow-indigo-500/40'} fixed top-28 right-4 border shadow-lg px-4 py-2 rounded-lg flex items-center transition transform hover:scale-105`}
    >
      <img 
        src={darkMode?downloadDark:download} 
        alt="Download Icon" 
        className="w-6 h-6"
      />
    </a>
             <Footer darkMode={darkMode}/>
             </div>
            
    </div>
    </>
  );
}

export default App;

